export const getElementStylePropertyValue = (element: HTMLElement, cssPropertyName: string) => {
    const styles = window.getComputedStyle(element);

    const propertyValue = styles.getPropertyValue(cssPropertyName);

    return propertyValue;
};
